import config from '../_content-maps'
import {DI_NAME_IN_PARAMS} from '../index'

export default {
  props: {
    diNameInProps: {
      type: String
    }
  },
  data () {
    return {
      generalData: {},
      renderDialog: () => ''
    }
  },
  computed: {
    diName () {
      return this.diNameInProps || this.diNameInRoute
    },
    diNameInRoute () {
      return this.$route.params[DI_NAME_IN_PARAMS]
    },
    config () {
      return config[this.diName]
    },
    subConfig () {
      return this.config[this.$options.name.split('-').pop()]
    },
    keyMappingOriginal () {
      return this.config.keyMappingOriginal
    },
    keyMappingEntities () {
      return this.subConfig.keyMappingEntities
    },
    keyMappingEntitiesForUi () {
      return this.keyMappingEntities.filter(([key]) => !key.startsWith('_'))
    }
  },
  methods: {
    getPayload () {
      return {
        data: this.data,
        requestBody: this.requestBody,
        vm: this
      }
    },
    beforeTheDataIsPost (data) {
      this.keyMappingEntities.forEach(([, {beforeDataIsPost}]) => {
        beforeDataIsPost && beforeDataIsPost(data)
      })
    },
    refreshDialog () {
      this.renderDialog = () => ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/di-ding/pages/di-ding-mixin.js